// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"152":"b6289de2","423":"a7728e2b","436":"872ceb81","565":"e6199327","901":"b3fb9820","938":"317ee7f7"}[chunkId] + ".chunk.css";
};